<template>
    <div class="container-fluid" style="padding: 0px; overflow: hidden;">
        <div class="row">
            <div class="col">
                <div class="hero_banner">
                    <h2>Description of the Initiative</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-5 mb-5 container">
        <div class="justify-content-center row">
            <div class="col-lg-9">
                <div class="shadow-lg card">
                    <div class="card-body">
                        <div class="align-items-center row">
                            <div class="col-md-6">
                                <h2 class="text-primary-new">Why is Sleep Essential?</h2>
                                <p class="mt-4">Our
                                    need for sleep parallels our need for air, food, and water. Sleep serves a
                                    staggering variety of health-related functions, including adaptive inactivity, the
                                    amelioration of fatigue and sleepiness, mood regulation, memory consolidation,
                                    tissue repair, metabolic and glucose homeostasis, enhancement of innate and/or
                                    adaptive immunity, neural reorganization, and sleep-related macroscopic clearance of
                                    CNS waste (glymphatic clearance). Poor sleep health is linked to accidents,
                                    injuries, lost productivity, and the onset of diseases like depression, anxiety, and
                                    diabetes.</p>
                            </div>
                            <div class="col-md-6"><img src="@/assets/lady-3.jpg" alt="Girl" class="img-fluid rounded">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="bg_blue py-5">
        <div class="container">
            <div class="justify-content-center row">
                <div class="col-lg-9">
                    <div class="shadow-lg card">
                        <div class="card-body">
                            <div class="align-items-center row">
                                <div class="col-md-6"><img src="@/assets/Disorders.jpg" alt="Sleep Disorders Symptoms"
                                        class="img-fluid rounded"></div>
                                <div class="col-md-6">
                                    <h3 class="text-primary-new">The Problem</h3>
                                    <p class="text-primar mt-3">Sleep disorders are widespread, affecting over a third
                                        of the adult population in the US. Despite their prevalence, many individuals
                                        remain undiagnosed due to poor communication, lack of access to healthcare, and
                                        insufficient screening. As a result, sleep disorders go untreated, potentially
                                        leading to significant medical and psychiatric issues such as cognitive decline,
                                        hypertension, and depression.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="mt-5 container">
        <div class="justify-content-center row">
            <div class="col-lg-9">
                <div class="shadow-lg card">
                    <div class="card-body">
                        <div class="align-items-center row">
                            <div class="col-md-6">
                                <h3 class="text-primary-new">The Solution</h3>
                                <p class="mt-3">To address this problem, patients need tools to identify if they have
                                    sleep disorder symptoms and the ability to advocate for their care. We’ve developed
                                    a digital sleep health screener that assesses 13 sleep disorder symptoms, in
                                    minutes. The screener provides immediate results, and offers resources to guide
                                    patients to the next steps for diagnosis and treatment.</p>
                            </div>
                            <div class="col-md-6"><img src="@/assets/collage_new.png" alt="Girl" class="img-fluid">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-5 container">
        <div class="justify-content-center row">
            <div class="col-lg-9">
                <div class="shadow-lg card">
                    <div class="card-body">
                        <h3 class="text-primary-new">Outcomes</h3>
                        <p class="mt-3"><span class="underline text_bold">Short Term Outcome:</span> Provide all those
                            who are concerned about their sleep a means to assess their sleep health and to seek
                            clinical care with personalized data in hand.</p>
                        <p class="mt-3"><span class="underline text_bold">Long Term Outcome:</span> Make sleep health an
                            essential part of every healthcare conversation between patients and their medical
                            providers.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="max_width_1240_mauto mt-5 container">
        <div class="row">
            <div class="col">
                <div class="qrcode_wrapper d-flex">
                    <img src="@/assets/sleep_health_qr_code.png" alt="Qrcode">
                    <router-link class="MuiButton-contained green" to="/sleephealthscreen/terms-condition">Start My
                        Sleep
                        Assessment</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'DescriptionInitiativePage',
    components: {
    },

};
</script>

<style scoped>
.MuiButton-contained.green {
    background-color: green;
}

.MuiButton-contained.green:hover {
    background-color: green;
}

.bg_blue {
    background: rgb(25, 118, 210);
}

.hero_banner {
    background-image: url(../assets/description_banner.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 200px;
    box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 35%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.hero_banner h2 {
    color: #ffffff;
    font-size: 40px;
}

.text-primary-new {
    color: rgb(25 118 210) !important;
}

.text_bold {
    font-weight: 500;
}

.underline {
    text-decoration: underline;
}

@media screen and (max-width: 767px) {

    .terms_banner h2,
    .hero_banner h2 {
        font-size: 30px;
        text-align: center;
    }
    .hero_banner {
        height: 150px;
    }
}
</style>